module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Rybrand'd Group","short_name":"Rybrand'd","start_url":"/","background_color":"#ffffff","theme_color":"#f97316","display":"minimal-ui","icon":"src/images/group-logo-transp-cropped.png","icons":[{"src":"src/images/group-logo-transp-cropped.png","sizes":"192x192","type":"image/png"},{"src":"src/images/group-logo-transp-cropped.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"38b3f577f7bc6bc1a3499044bfe76cad"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
